module.exports = __webpack_public_path__ + "img/login-bg.c7ecc096.png";